<template>
    <layout :title="$attrs.title" :required="$attrs.required">
        <div class="custom-input-container flex flex-row flex-row-aic">
            <van-field class="input-padding" :value="value" :type="inputType" :placeholder="$attrs.placeholder || '请输入'"
                @input="value => $emit('input', value)" @clear="() => $emit('input', '')" clearable
                :maxlength="$attrs.maxlength || undefined"
                :show-word-limit="typeof $attrs.showWordLimit === 'undefined' ? true : $attrs.showWordLimit" rows="3"
                autosize :readonly="$attrs.readonly || false" :disabled="$attrs.disabled" />
        </div>
    </layout>
</template>

<style lang="less" scoped>
.custom-input {
    &-container {
        .input-padding {
            padding: 3px 0;
        }
    }
}
</style>

<script>
import Layout from './Layout.vue';
export default {
    name: 'CInput',
    components: {
        Layout
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        inputType: {
            type: String,
            default: 'text'
        }
    }
}
</script>